import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

export type LogView = 'god' | 'player'

interface LogPerspectiveControlsProps {
  className?: string
  firstPersonLabel: string
  godLabel: string
  label: string
  logView: LogView
  onLogViewChange?: (view: LogView) => void
}

export function LogPerspectiveControls({
  className,
  firstPersonLabel,
  godLabel,
  label,
  logView,
  onLogViewChange,
}: LogPerspectiveControlsProps) {
  return (
    <div className={cn('min-w-0 max-w-full', className)}>
      <div
        role="group"
        aria-label={label}
        className="flex max-w-full items-center gap-1 overflow-x-auto rounded-lg border border-border/60 bg-muted/30 p-1"
        data-testid="log-perspective-controls"
      >
        <Button
          type="button"
          size="sm"
          className="h-auto min-h-11 min-w-max flex-1 whitespace-nowrap px-3 py-2 text-center leading-tight"
          variant={logView === 'player' ? 'secondary' : 'ghost'}
          aria-pressed={logView === 'player'}
          data-testid="log-view-player"
          onClick={() => onLogViewChange?.('player')}
        >
          {firstPersonLabel}
        </Button>
        <Button
          type="button"
          size="sm"
          className="h-auto min-h-11 min-w-max flex-1 whitespace-nowrap px-3 py-2 text-center leading-tight"
          variant={logView === 'god' ? 'secondary' : 'ghost'}
          aria-pressed={logView === 'god'}
          data-testid="log-view-god"
          onClick={() => onLogViewChange?.('god')}
        >
          {godLabel}
        </Button>
      </div>
    </div>
  )
}
